'use client';

import builder, { useIsPreviewing } from '@builder.io/react';
import { notFound } from 'next/navigation';
import { Fragment } from 'react';

import BuilderComponent from 'components/Builder/BuilderComponent';
import { ComponentGenerator, type ComponentGeneratorProps } from 'components/Builder/ComponentGenerator';

import type { FC } from 'react';

export interface BuilderContentProps extends ComponentGeneratorProps {
  content?: any;
  model: string;
}

const apiReadKey = process.env.NEXT_PUBLIC_BUILDER_API_KEY || '';

builder.init(apiReadKey);

const BuilderContent: FC<BuilderContentProps> = ({ components, content, model }) => {
  const isPreviewing = useIsPreviewing();

  const isLearningCenterOnly = content?.data?.templateInfo?.siteAvailability === 'LC Only';

  if ((!isPreviewing && !content) || isLearningCenterOnly) {
    return notFound();
  }

  return (
    <Fragment>
      {isPreviewing ? (
        <BuilderComponent model={model} content={content} />
      ) : (
        <ComponentGenerator components={components} />
      )}
    </Fragment>
  );
};
export default BuilderContent;
